import React, { FC, useContext } from 'react';

import { PolicyContext } from 'Policies/utils';
import {
  editVehicleCoveragePermissionsPolicy,
  editCoveragesRequiringSignaturesPermissionsPolicy,
} from 'Admin/authPolicies';

import styles from './styles.module.css';
import { CoverageInput } from './CoverageInput';
import { CoverageFormOptionType } from './types';

type VehicleLevelCoveragesProps = {
  coverageOptions: Array<CoverageFormOptionType>;
  endorsementOptions: Array<CoverageFormOptionType>;
  identifier: string;
  display: string;
};

// coverage identifiers that require signatures
const COVERAGE_SIGNATURE_REQUIRED = ['COLL'];

export const VehicleLevelCoverages: FC<VehicleLevelCoveragesProps> = ({
  coverageOptions,
  endorsementOptions,
  identifier: vehicleIdentifier,
  display,
}) => {
  const { canEndorseDuringRegionalEvents, resourceEffectiveGrants } =
    useContext(PolicyContext);

  const canEditVehicleCoverages =
    canEndorseDuringRegionalEvents &&
    editVehicleCoveragePermissionsPolicy(resourceEffectiveGrants);

  const canEditCoveragesRequiringSignatures =
    canEditVehicleCoverages &&
    editCoveragesRequiringSignaturesPermissionsPolicy(resourceEffectiveGrants);

  return (
    <div className={styles.vehicleCoveragesContainer}>
      <h1>{display}</h1>
      {coverageOptions.map((coverage) => (
        <CoverageInput
          key={coverage.identifier}
          type="coverage"
          coverage={coverage}
          formKey={`vehiclesCoverages.${vehicleIdentifier}.coverages.${coverage.identifier}`}
          disabled={
            COVERAGE_SIGNATURE_REQUIRED.includes(coverage.identifier)
              ? !canEditCoveragesRequiringSignatures
              : !canEditVehicleCoverages
          }
        />
      ))}
      {endorsementOptions.map((coverage) => (
        <CoverageInput
          key={coverage.identifier}
          type="endorsement"
          coverage={coverage}
          formKey={`vehiclesCoverages.${vehicleIdentifier}.endorsements.${coverage.identifier}`}
          disabled={!canEditVehicleCoverages}
        />
      ))}
    </div>
  );
};

VehicleLevelCoverages.displayName = 'VehicleLevelCoverages';
